// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .ErrorDialogue {
  position: absolute;
  display: flex;
}
:host .ErrorDialogue .ErrorDialogue_triangle {
  content: "";
  width: 0px;
  height: 0px;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 10px solid var(--ods-color-red-50);
  margin-top: 47px;
  z-index: 3;
}
:host .ErrorDialogue .ErrorDialogue_icon-area {
  background-color: var(--ods-color-red-50);
  width: 43px;
  height: 114px;
  text-align: center;
  z-index: 3;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  box-shadow: 5px 5px 5px rgba(194, 192, 192, 0.397);
}
:host .ErrorDialogue .ErrorDialogue_icon-area::after {
  background-image: url(https://content.upmchp.com/employerplace/icons/whiteBG-error.svg);
  background-size: 22px 22px;
  display: inline-block;
  width: 22px;
  height: 22px;
  margin-top: 46px;
  z-index: 3;
  content: "";
}
:host .ErrorDialogue .ErrorDialogue_content {
  background-color: white;
  font-size: 0.8rem;
  width: auto;
  height: 114px;
  z-index: 3;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  border: 1px solid var(--ods-color-red-10) 0;
  box-shadow: 5px 5px 5px rgba(194, 192, 192, 0.397);
}
:host .ErrorDialogue .ErrorDialogue_content .content-title {
  height: 50px;
  font-size: 18px;
  font-weight: 700;
  color: var(--ods-color-red-50);
  padding: 16px;
  border-radius: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/error-dialogue/error-dialogue.component.scss"],"names":[],"mappings":"AAEE;EACE,kBAAA;EACA,aAAA;AADJ;AAGI;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,kCAAA;EACA,qCAAA;EACA,gDAAA;EACA,gBAAA;EACA,UAAA;AADN;AAKI;EACE,yCAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,2BAAA;EACA,8BAAA;EACA,kDAAA;AAHN;AAMI;EACE,uFAAA;EACA,0BAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,WAAA;AAJN;AAOI;EACE,uBAAA;EACA,iBAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;EACA,4BAAA;EACA,+BAAA;EACA,2CAAA;EACA,kDAAA;AALN;AAOM;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,8BAAA;EACA,aAAA;EACA,kBAAA;AALR","sourcesContent":["\n:host {\n  .ErrorDialogue {\n    position: absolute;\n    display: flex;\n\n    .ErrorDialogue_triangle {\n      content: \"\";\n      width: 0px;\n      height: 0px;\n      border-top: 10px solid transparent;\n      border-bottom: 10px solid transparent;\n      border-right: 10px solid var(--ods-color-red-50);\n      margin-top: 47px;\n      z-index: 3;\n\n    }\n\n    .ErrorDialogue_icon-area {\n      background-color: var(--ods-color-red-50);\n      width: 43px;\n      height: 114px;\n      text-align: center;\n      z-index: 3;\n      border-top-left-radius: 5px;\n      border-bottom-left-radius: 5px;\n      box-shadow: 5px 5px 5px rgba(194, 192, 192, 0.397);\n    }\n\n    .ErrorDialogue_icon-area::after {\n      background-image: url(https://content.upmchp.com/employerplace/icons/whiteBG-error.svg);\n      background-size: 22px 22px;\n      display: inline-block;\n      width: 22px;\n      height: 22px;\n      margin-top: 46px;\n      z-index: 3;\n      content: \"\";\n    }\n\n    .ErrorDialogue_content {\n      background-color: white;\n      font-size: 0.8rem;\n      width: auto;\n      height: 114px;\n      z-index: 3;\n      border-top-right-radius: 5px;\n      border-bottom-right-radius: 5px;\n      border: 1px solid var(--ods-color-red-10)0;\n      box-shadow: 5px 5px 5px rgba(194, 192, 192, 0.397);\n\n      .content-title {\n        height: 50px;\n        font-size: 18px;\n        font-weight: 700;\n        color: var(--ods-color-red-50);\n        padding: 16px;\n        border-radius: 5px;\n      }\n\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
